<script>
/**
 * ****************************************************************************
 * @description     :   Main component for popup search project
 * @created at      :   2022/09/12
 * @created by      :   ANS897 – hieunm@ans-asia.com
 * @package         :   STworks
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
import repository from '@/utils/repository';
/**
 * Import template
 */
import template from './template.html';

/**
 * Define component chat for show page chat
 */
var PopupSearchProject = {
    template: template,
    props: {
        onSelected: Function,
        onClose: Function
    },
    data() {
        return {
            search: '',
            searching: false,
            resultSearch: []
        };
    },
    mounted() {
        setTimeout(() => {
            this.$refs.inputSearch?.focus();
        }, 500);
    },
    methods: {
        doSearch(e) {
            if (this.searching) {
                return;
            }
            this.searching = true;
            repository
                .get(`gs/gs0520i/search/project`, {
                    params: {
                        p003: e.target.value
                    }
                })
                .then((res) => {
                    this.searching = false;
                    const { data } = res;
                    if (data.Code === 200) {
                        this.resultSearch = data.Data;
                        console.log('data.Data: ', data.Data);
                    } else {
                        this.resultSearch = [];
                    }
                });
        },
        selectRow(item) {
            if (this.onSelected) {
                this.onSelected(item);
            }
            this.onClose();
        }
    }
};
export default PopupSearchProject;
</script>
